
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useTranslations } from "@/hooks/useTranslations";

export const PasswordChangeForm = () => {
  const { t } = useTranslations("settings");
  const [loading, setLoading] = useState(false);
  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (passwords.new !== passwords.confirm) {
      toast.error("As novas passwords não coincidem");
      setLoading(false);
      return;
    }

    try {
      const { error } = await supabase.auth.updateUser({
        password: passwords.new
      });

      if (error) throw error;

      toast.success("Password atualizada com sucesso");
      setPasswords({ current: "", new: "", confirm: "" });
    } catch (error) {
      console.error('Error updating password:', error);
      toast.error("Erro ao atualizar password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleChangePassword} className="space-y-4 bg-white/90 dark:bg-gray-800/90 p-4 rounded-xl">
      <div className="space-y-2">
        <Label htmlFor="current-password">{t("security.currentPassword")}</Label>
        <Input
          id="current-password"
          type="password"
          value={passwords.current}
          onChange={(e) => setPasswords(prev => ({ ...prev, current: e.target.value }))}
          className="rounded-xl"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="new-password">{t("security.newPassword")}</Label>
        <Input
          id="new-password"
          type="password"
          value={passwords.new}
          onChange={(e) => setPasswords(prev => ({ ...prev, new: e.target.value }))}
          className="rounded-xl"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="confirm-password">{t("security.confirmPassword")}</Label>
        <Input
          id="confirm-password"
          type="password"
          value={passwords.confirm}
          onChange={(e) => setPasswords(prev => ({ ...prev, confirm: e.target.value }))}
          className="rounded-xl"
        />
      </div>

      <Button type="submit" disabled={loading} className="rounded-xl">
        {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {t("security.updateButton")}
      </Button>
    </form>
  );
};
